import React from "react";

// Inner-page banner matching the site's elegant style
const PageBanner = ({ eyebrow, title, subtitle, image }) => {
  return (
    <section className="relative h-[46vh] min-h-[340px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${image})` }}
      />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(40,37,36,0.45) 0%, rgba(40,37,36,0.35) 50%, rgba(40,37,36,0.55) 100%)" }} />
      <div className="relative z-10 text-center px-6">
        {eyebrow && (
          <p className="font-sans-el text-white/85 tracking-[0.4em] uppercase text-xs mb-4">
            {eyebrow}
          </p>
        )}
        <h1 className="brand-title text-white text-5xl md:text-7xl uppercase" style={{ letterSpacing: "0.08em" }}>
          {title}
        </h1>
        <div className="divider-ornament mt-6">
          <span className="line" style={{ backgroundColor: "rgba(255,255,255,0.7)" }} />
          <span className="dot" style={{ borderColor: "rgba(255,255,255,0.8)" }} />
          <span className="line" style={{ backgroundColor: "rgba(255,255,255,0.7)" }} />
        </div>
        {subtitle && (
          <p className="font-serif-el text-white/90 text-lg md:text-xl mt-6 max-w-2xl mx-auto italic">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageBanner;
